// extracted by mini-css-extract-plugin
module.exports = {"root":"ChangeStatusModal-root-2355da457a101ddf8e95f27a5fe21b2b"};